import { render, staticRenderFns } from "./icon--solid.vue?vue&type=template&id=22dedeb4&scoped=true"
import script from "./icon--solid.vue?vue&type=script&lang=js"
export * from "./icon--solid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dedeb4",
  null
  
)

export default component.exports